import { createEvent, createStore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Chargeback, ChargebackPayload } from '../types'

export const chargebackMounted = createEvent<{ id: string }>()

export const updateChargebackMounted = createEvent<{
  id: string
  payload: ChargebackPayload
}>()

export const getChargeback = fx<void, Chargeback>({
  method: 'GET',
})

export const updateChargeback = fx<ChargebackPayload, Chargeback>({
  method: 'PUT',
})

export const $chargeback = createStore<Chargeback | null>(null)
  .on(getChargeback.doneData, (_, data) => data.body)
  .reset(chargebackMounted)

sample({
  clock: chargebackMounted,
  fn: ({ id }) => ({ url: `/finance/chargeback/${id}` }),
  target: getChargeback,
})

sample({
  clock: updateChargebackMounted,
  fn: ({ id, payload }) => ({
    url: `/finance/chargeback/${id}`,
    body: payload,
  }),
  target: updateChargeback,
})
